import { render, staticRenderFns } from "./StationLocationSensorVariableCard.vue?vue&type=template&id=68e4c536&scoped=true&"
import script from "./StationLocationSensorVariableCard.vue?vue&type=script&lang=js&"
export * from "./StationLocationSensorVariableCard.vue?vue&type=script&lang=js&"
import style0 from "./StationLocationSensorVariableCard.vue?vue&type=style&index=0&id=68e4c536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e4c536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDivider,VRow,VTextField})
